export default "__VITE_ASSET__aa834e88__"